/* eslint-disable */
import { useEnumApi } from "contexts/EnumApiContext";
import { equipmentFaultStatusColors } from "data/data";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ECharts from 'echarts-for-react';

const chartDataInit = {
  series: [
    {
      name : '',
      type: 'gauge',
      startAngle: 90,
      endAngle: -270,
      pointer: {
        show: false
      },
      itemStyle: {
        color: "#4caf50",
        borderColor:'#000',
        borderWidth:1
      },
      progress: {
        show: true,
        overlap: false,
        roundCap: true,
        clip: false,
      },
      axisLine: {
        lineStyle: {
          width: 10,
          color:[[1,'#c0c0c0']]
        }
      },
      splitLine: {
        show: false,
        distance: 0,
        length: 10
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        show: false,
        distance: 50
      },
      data: [ ],
      title: {
        fontSize: 14,
        color : '#fff'
      },
      detail: {
        show : false,
        // width: 50,
        // height: 14,
        // fontSize: 14,
        // color: 'inherit',
        // borderColor: 'inherit',
        // borderRadius: 20,
        // borderWidth: 0,
        // formatter: '{value}%'
      }
    }
  ]
}

export function StatusChart({EquipmentFaultStatusList, statusDatas}) {
  const { getEnumValueByEnumName } = useEnumApi();
  const { t } = useTranslation();

  const [options, setOptions] = useState([chartDataInit]);
  const [isLoading, setIsLoading] = useState(false);
  // const list = getEnumValueByEnumName("EquipmentFaultStatus");
// console.log('statusCharts', statusDatas)
  useEffect(()=>{
    // console.log(statusDatas)
    // if (!isLoading) {
    //if (statusDatas && statusDatas.length > 0) {
      const sum = statusDatas.reduce((acc, cur, i)=> {
        // console.log(acc, cur.count, i);
        return acc + parseInt(cur.count);
      }, 0)
      // console.log(sum);
      let chartGradeData = [];
      // const grades = equipmentFaultGrade;
      // // console.log(grades)
      // let chartGradeData = [];
      // if (grades) {
      //   grades && grades.map(function(grade, k) {
      //     let optionsCopy = {...chartDataInit};
      //     let chartDataCopy = JSON.parse(JSON.stringify(optionsCopy));
      //     let chartGradeDataCopy = {
      //       // value: 40,
      //       // name: 'Good',
      //       title: {
      //         offsetCenter: ['0%', '0%']
      //       },
      //       detail: {
      //         valueAnimation: true,
      //         offsetCenter: ['0%', '15%']
      //       }
      //     };
      //     // console.log(grade)
      //     chartDataCopy.series[0].name = grade.code;
      //     chartDataCopy.series[0].itemStyle.color = grade.color;
      //     chartDataCopy.series[0].title.color = grade.color;
      //     // chartGradeDataCopy.name = grade.title;
      //     // chartGradeDataCopy.title = grade.title;
      //     // chartGradeDataCopy.color = grade.color;
      //     if (statusDatas) {
      //       let gData = statusDatas.filter(gItem => grade.items.includes(gItem.id))
      //       let cnt = 0;
      //       if (gData && gData.length > 0) {
      //         for(let d=0 ; d<gData.length ; d++) {
      //           cnt += gData[d].count;
      //         }
      //       }
      //       chartGradeDataCopy.name = grade.title+'\n'+cnt;
      //       // chartGradeDataCopy.cnt = cnt;
      //       if (cnt > 0) {
      //         chartGradeDataCopy.value = Math.round(cnt/sum*100);
      //       } else {
      //         chartGradeDataCopy.value = 0;  
      //       }
      //     } else {
      //       chartGradeDataCopy.name = grade.title+'\n0';
      //       // chartGradeDataCopy.cnt = 0;
      //       chartGradeDataCopy.value = 0;
      //     }
      //     chartDataCopy.series[0].data.push(chartGradeDataCopy);
      //     chartGradeData.push(chartDataCopy);
      //     // console.log(chartGradeDataCopy)
      //   })
      // }
      // setTimeout(()=>{
        
        // console.log(EquipmentFaultStatusList)
        if (EquipmentFaultStatusList) {
          EquipmentFaultStatusList && EquipmentFaultStatusList.map(function(item, i) {
            // console.log(item)
            if (!item.code.startsWith("O4_C")) {
              // let chartDataCopy = {};
              // chartDataCopy.title = item.title;
              let optionsCopy = {...chartDataInit};
              let chartDataCopy = JSON.parse(JSON.stringify(optionsCopy));
              let chartGradeDataCopy = {
                // value: 40,
                // name: 'Good',
                title: {
                  offsetCenter: ['0%', '0%']
                },
                detail: {
                  valueAnimation: true,
                  offsetCenter: ['0%', '15%']
                }
              };
              const itemColor = [equipmentFaultStatusColors.find(data => data.code === item.code)?.color];
              chartDataCopy.series[0].name = item.code;
              chartDataCopy.series[0].itemStyle.color = itemColor;
              chartDataCopy.series[0].title.color = itemColor;
              // chartGradeDataCopy.name = item.title;

              if (statusDatas) {
                let sData = statusDatas.filter(sItem => sItem.id === item.code);
                if (sData && sData.length > 0) {
                  chartGradeDataCopy.name = item.title+'\n'+sData[0].count;
                  // chartGradeDataCopy.cnt = sData[0].count;
                  chartGradeDataCopy.value = Math.round(sData[0].count/sum*100);
                } else {
                  chartGradeDataCopy.name = item.title+'\n0';
                  // chartGradeDataCopy.cnt = 0;
                  chartGradeDataCopy.value = 0;
                }
              } else {
                chartGradeDataCopy.name = item.title+'\n0';
                // chartGradeDataCopy.cnt = 0;
                chartGradeDataCopy.value = 0;
              }
              chartDataCopy.series[0].data.push(chartGradeDataCopy);
              chartGradeData.push(chartDataCopy);
            }
          })
          // setChartGradeDatas(chartGradeData);
        }
        // console.log(chartGradeData)
        setOptions(chartGradeData);
      // }, 2000)
      setIsLoading(true);
      
    // } else {
    //   // setIsLoading(false);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[statusDatas, isLoading]);

  if (isLoading) {
    // setIsLoading(false);
    // const addString = "&searchSubway="+subwayCode+"&searchWorkingPart="+workingPartId+"&searchStation="+stationId;
    const addString = "";
    return (
    <>
      {options && options.map(function(item, i) {
        return (
          <div key={i} style={{ width: "22%" }}>
            {/* <Link to={"/equipment?searchStatus="+(item.series[0].name==='EG_AB'?'O9_G':(item.series[0].name==='EG_CD'?'O1_F':'O2_M'))+addString}> */}
            <Link to={"/equipment?searchStatus="+item.series[0].name+addString}>
              <ECharts
                option={item}
                opts={{ renderer: 'svg', width: '150px', height: '150px'}}
                style={{ height: "150px" }}
              />
            </Link>
          </div>
        )
      })}
    </>
    )
  }
}

export default StatusChart;
